import { styled } from "utils";
import Link, { LinkProps } from "next/link";
import { Spinner } from "./spinner";

const StyledButton = styled("button", {
  paddingX: "$3",
  paddingY: "$2",
  height: 56,
  width: "100%",
  borderRadius: "$1",
  border: "none",
  fontWeight: "$extrabold",
  cursor: "pointer",
  position: "relative",
  variants: {
    variant: {
      primary: {
        backgroundColor: "$primary",
        color: "$white",
        "&:hover": { backgroundColor: "$primaryHover" },
        "&:active": { backgroundColor: "$primaryActive" },
        "&:disabled": { backgroundColor: "$grey300" },
      },
    },
  },
});

const SpinnerWrapper = styled("span", {
  position: "absolute",
  height: "100%",
  left: "$3",
  top: -12,
});

type Props = React.ComponentProps<typeof StyledButton> & {
  loading?: boolean;
};

const Button = ({ loading, disabled, children, ...props }: Props) => (
  <StyledButton variant="primary" disabled={loading || disabled} {...props}>
    {loading ? (
      <>
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
        {children}
      </>
    ) : (
      children
    )}
  </StyledButton>
);

const ButtonLink: React.FC<LinkProps> = ({
  passHref = true,
  children,
  ...props
}) => {
  return (
    <Link passHref={passHref} {...props}>
      <div>{children}</div>
    </Link>
  );
};

export { Button, ButtonLink };
